module.exports = __webpack_public_path__ + "static/clients-greentree.e7aeb9d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/clients-greentree.png
// module id = 929
// module chunks = 241767136424496